import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

export const message =
  'A LINQ software update is scheduled for early Wednesday morning. If you are planning to complete a workflow run at this time make sure to delay the run start till after the update is complete.';

export const MaintenanceBanner = (): JSX.Element => {
  return (
    <Alert severity="info">
      <AlertTitle>
        <strong>Upcoming software update</strong>
      </AlertTitle>
      {message}
    </Alert>
  );
};
